import { ButtonProps, Button as EbdsButton } from '@boschebike/ebds-react';
import { FunctionComponent } from 'react';

export const Button: FunctionComponent<ButtonProps> = ({ icon, ...props }) => (
  <EbdsButton
    icon={icon}
    {...props}
  />
);
